import { render, staticRenderFns } from "./MfaDetail.vue?vue&type=template&id=22b185b8"
import script from "./MfaDetail.vue?vue&type=script&lang=js"
export * from "./MfaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports